import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  query Church {
    allChurchesCsv(sort: {order: ASC, fields: english_name_I}) {
      edges {
        node {
          chinese_name_I
          chinese_name_II
          english_name_I
          english_name_II
					latitude
					longitude
          id
					established_year
					telephone_number
					full_address
          date_sketch_created
        }
      }
    }
  }
`

const useChurchesData = () => {
  let {
    allChurchesCsv: { edges }
  } = useStaticQuery(query)

  let data = edges.map(x => x.node)

  return data
}

export default useChurchesData
